// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__15VTL","brand":"Login_brand__2trj6","noPlaceholder":"Login_noPlaceholder__14yrN"};